import { c as _c } from "react/compiler-runtime";
import { Box } from "@chakra-ui/react";
import { ReactNode } from "react";
export interface MapLegendProps {
  children: ReactNode;
}
export const MapLegendContainer = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <Box data-testid="map-legend" bg="cardBg" borderRadius="card" boxShadow="elevated" px="4" py="5" width="legendCard">{children}</Box>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};